export default {
  errors: {
    googleNotAvailable: 'El acceso con Google aún no está disponible para esta cuenta. Para continuar, ingresá tu contraseña.',
  },
  login: {
    needHelp: '¿Necesitás ayuda?',
    title: 'Ingresá a tu cuenta',
    subtitle: 'Seguí ganando tiempo y tranquilidad',
    form: {
      email: {
        placeholder: 'Ingresá tu correo electrónico',
      },
      password: {
        placeholder: 'Ingresá tu contraseña',
      },
      magicLinkButton: {
        tooltip: 'Recibí un link para ingresar sin contraseña.',
      },
    },
    footer: {
      dontHaveAccount: '¿Aún no tenés una cuenta?',
      signUp: 'Registrate gratis',
      allProducts: 'Ingresá con las mismas credenciales a todos los productos de Alegra.',
    },
  },
  register: {
    title: '¡Alegra es gratis por 15 días!',
    form: {
      email: {
        placeholder: 'Ingresá tu correo electrónico',
      },
      password: {
        placeholder: 'Ingresá una contraseña',
      },
      coupon: {
        label: '¿Tenés un código promocional?',
        placeholder: 'Ingresalo aquí',
      },
      magicLinkButton: {
        tooltip: 'Recibí un link para registrarte sin contraseña.',
      },
    },
    footer: {
      haveAccount: '¿Ya tenés una cuenta?',
      login: 'Iniciá sesión',
    },
  },
  doubleFA: {
    subtitle: 'Ingresá el código de 6 dígitos generado en tu app de autenticación.',
    anotherOption: '¿Precisás otra opción para autenticarte?',
    backupCodeSubtitle: 'Usá uno de tus códigos de respaldo para autenticarte.',
    unableToAuth: '¿Seguís sin poder autenticarte?',
  },
  passwordUpdate: {
    title: 'Mantené tu cuenta segura',
    subtitle:
      'Necesitás actualizar tu contraseña para reforzar tu seguridad, enviamos a <b>{email}</b> los pasos para cambiarla e iniciar sesión.',
    subtitleNoProvider:
      'Necesitás actualizar tu contraseña para reforzar tu seguridad. Enviamos a <b>{email}</b> los pasos para cambiarla e iniciar sesión, podés buscarlos en tu bandeja de entrada o spam.',
    footerContactUs: 'Contactanos',
    modal: {
      title: '¿Necesitás ayuda?',
      subtitle: 'Estas son las opciones de soporte disponibles para vos',
      chat: {
        title: 'Hablá con un representante por chat',
        text: 'Nuestro chat está disponible de lunes a viernes entre las {start}. y las {end}.',
      },
      call: {
        title: 'Llamá a un representante',
        text: 'Encontrá el número de soporte para tu país, horario de atención y llamanos.',
      },
    },
  },
  magicLink: {
    login: {
      main: {
        title: '¡Ingresá desde tu correo!',
        subtitle: 'Utilizá un link mágico para ingresar sin contraseña.',
      },
      sended: {
        subtitle:
          'Buscalo en tu bandeja de entrada o revisá si llegó a la carpeta de spam <br class="hidden md:block" /><b>{email}</b>',
      },
      resended: {
        text: 'Podés solicitar otro link en:',
        textTime:
          'Podés usar otro método para iniciar sesión o solicitar un nuevo link a las {time}',
      },
    },
    signup: {
      main: {
        title: '¡Registrate desde tu correo',
        subtitle: 'Usá un link mágico para registrarte sin contraseña.',
      },
      sended: {
        subtitle:
          'Buscalo en tu bandeja de entrada o revisá si llegó a la carpeta de spam <br class="hidden md:block" /><b>{email}</b>',
      },
      resended: {
        text: 'Podés solicitar otro link en:',
        textTime: 'Podés usar otro método para registrarte o solicitar un nuevo link a las {time}',
      },
    },
    expired: {
      subtitle:
        'Tené en cuenta que el tiempo de disponibilidad es de <b>30 minutos</b> y solo puede ser usado una vez.',
      sendButton: 'Enviar un nuevo enlace',
    },
  },
  recoverPassword: {
    request: {
      footer: {
        haveAccount: '¿Aún no tenés una cuenta?',
      },
    },
    change: {
      title: 'Restablecé tu contraseña',
    },
  },
  registerEducationAlliance: {
    form: {
      information: {
        description:
          'Si no pertenecés a una alianza educativa o deseas usar Alegra para tu negocio, creá una cuenta ',
      },
    },
  },
  validateIdentity: {
    requestWhatsApp: {
      description: 'Ingresá los últimos 4 dígitos de tu número de WhatsApp.',
    },
    otp: {
      title: 'Ingresá el código de seguridad',
      description: {
        whatsapp: 'Revisá tu WhatsApp e ingresá el código de 6 dígitos.',
        email: 'Revisá el correo {email} e ingresá el código de 6 dígitos para continuar.',
      },
      errorCode: 'El código es incorrecto. Intentá nuevamente o solicita uno nuevo.',
    },
    temporarilyBlocked: {
      description:
        'Por tu seguridad, hemos suspendido el acceso después de 3 intentos fallidos. Por favor, contactá a soporte para ingresar a tu cuenta.',
      options: {
        email: {
          label: 'Escribínos por correo',
        },
        chat: {
          label: 'Hablá con un agente',
        },
      },
    },
  },
}
